<template>
	<el-row>
		<el-row style="background-color: #f9f9f9;">
			<el-col :span="14" style="display: flex;align-items: center;">
				<!-- 图片 -->
				<div>
					<el-image :src="info.themePic" style="width: 200px;height: 120px;" />
				</div>
				<div
					style="color: #99a0b2;width: 70%; height: 120px;margin: 15px 20px;display: flex;flex-direction: column;justify-content: space-around;align-items: auto; ">
					<!-- 标题 -->
					<div style="color: #66676a;font-weight: bold">{{ info.courseName }}(共{{ info.num }}节课)</span></div>
					<!-- 副标题 -->
					<span>{{ info.courseSubTitle }}</span>
					<div style="display: flex;width: auto;">
						<!-- 方向 -->
						<div
							style="width: auto;height: 25px;background-color: #e4e4e4;text-align: center;line-height: 25px;">
							<span style="color: #66676a">{{ info.directionName }}</span>
						</div>
						<!-- 类别 -->
						<div
							style="width: auto;height: 25px;background-color: #e4e4e4;text-align: center;line-height: 25px;margin-left: 10px;">
							<span style="color: #66676a">{{ info.courseCategoryName.join('>') }}</span>
						</div>
					</div>
					<div>
						<!-- 是否免费以及价钱 -->
						<span>{{ info.free == 1 ? "付费" : info.free == 0 ? '免费' : '' }}:</span><span
							style="color: #fe181f;font-size: 15px;">￥{{
								info.coursePrice ? info.coursePrice : 0
							}}元</span>
					</div>
				</div>
			</el-col>
			<el-col :span="10" style="height: 152px;display: flex;flex-direction: column;">
				<div style="display: flex;align-items: center;height: 50px;">
					<div style="width: 200px;">
						<span>{{ info.playNum }}播放</span>
					</div>
					<div style="width: 230px;">
						<span>发布者:{{ info.publisherName ? info.publisherName : "后台" }}</span>
					</div>
					<div style="width: 200px;">
						<span>发布时间:{{ info.created }}</span>
					</div>
				</div>
				<div
					style="width: 90%;height: 50px;color: #666666;display: flex;align-items: center;justify-content: flex-end;">
					<span>浏览/点赞/分享/购买/观看(人次)</span>
					<span style="padding: 0 10px;">{{ info.lookNum }}/{{ info.praiseNum }}/{{ info.shareNum }}/{{
						info.buyNum
					}}/{{ info.playNum }}</span>
				</div>
				<div style="width: 90%;height: 50px;display: flex;align-items: center;justify-content: flex-end;">
					<el-button type="infor" size="mini" style="color: #0081FF;" @click="xiugai()">修改信息</el-button>
					<el-button type="infor" size="mini" style="color: #0081FF;" @click="sxjia()">
						{{ info.status == 1 ? "上架" : "下架" }}
					</el-button>
				</div>
			</el-col>
		</el-row>
		<el-row style="background-color: #f9f9f9;margin: 20px 0px;">
			<el-col :span="21" style="height: 50px;">课件目录</el-col>
			<el-col :span="3" style="height: 50px;">
				<el-button type="infor" style="color: #0000ff;" size="mini" @click="addZangJie()">新增章节+</el-button>
				<el-button type="text" style="color: #409EFF;" size="mini" @click="xiugai2()">编辑课程介绍</el-button>
			</el-col>
		</el-row>
		<el-row v-for="(item, index) in tableData" :key="index">
			<div style="display: flex;justify-content: space-between;">
				<div style="font-size: 15px;margin-left: 10px;">第{{ item.chapterNo }}章 {{ item.chapterName }}</div>
				<div style="margin-right: 20px;">
					<el-button size="mini" type="infor" @click="addKeCheng(item)">新增课程</el-button>
					<el-button size="mini" type="text" @click="xgZangJie(item)">编辑</el-button>
					<el-button size="mini" type="text" @click="del(item)">删除</el-button>
				</div>
			</div>
			<div v-for="(item2, index2) in item.clrLessonDOList" :key="index2"
				style="width: 100%;height: 50px;border-bottom: 1px solid #bbbabe;display: flex;align-items: center;justify-content: space-between;">
				<div style="margin-left: 20px;width: 300px;">
					<div style="font-size: 14px;margin-left: 10px;">{{ item2.lessonName }}</div>
				</div>
				<div style="width: 200px;">
					<div v-if="item2.fileType == '1'">
						视频
						<div class="el-icon-video-play" style="borderr:1px soild #0074E6;" @click="see(item2)"> </div>
						时长 : {{ item2.length }}
					</div>
					<div v-if="item2.fileType == '2'">
						音频
						<div class="el-icon-video-play" style="borderr:1px soild #0074E6;" @click="see(item2)"> </div>
						时长 : {{ item2.length }}
					</div>
					<div v-if="item2.fileType == '3'">
						图文
						<div class="el-icon-video-play" style="borderr:1px soild #0074E6;" @click="see(item2)"> </div>
					</div>
				</div>
				<div style="width: 200px;">
					<span v-if="item2.testType == 0">随堂检测-无</span>
					<span v-if="item2.testType == 1">随堂检测-考试</span>
					<span v-if="item2.testType == 2">随堂检测-作业</span>
					<span v-if="item2.testType == 3">随堂检测-实践</span>
				</div>
				<div style="width: 200px;">
					{{ item2.lessonPlayNum }}播放量
				</div>
				<div style="width: 200px;">
					{{ item2.created }}
				</div>
				<div style="width: 200px;display: flex;align-items: center;justify-content: space-around;">
					<el-switch v-model="item2.free" :active-value="0" :inactive-value="1" active-text="免费"
						inactive-text="付费" @change="handleStatusChange(item2)" active-color="#868686"
						inactive-color="#0e9939">
					</el-switch>
					<el-button size="mini" type="text" @click="bj(item2)">编辑</el-button>
					<el-button size="mini" type="text" @click="delLesson(item2)">删除</el-button>
				</div>
			</div>
		</el-row>
		<el-dialog :title="title" :visible.sync="centerDialogVisible" width="60%" center @change="gb()">
			<el-form label-position="right" label-width="250px" :rules="xgInfoRules" ref="xgInfo" :model="xgInfo">
				<div v-if="isShow">
					<el-form-item label="方向:" prop="direction">
						<el-select size="mini" class="margin-left-10" v-model="xgInfo.direction">
							<el-option v-for="item in options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="分类:" prop="category">
						<el-cascader size="mini" v-model="xgInfo.category" :options="options2" :props="cateListProps"
							clearable style="width: 300px;" />
					</el-form-item>
					<el-form-item label="标题:" prop="courseName">
						<el-input placeholder="50字" maxlength="50" size="mini" style="width: 400px"
							v-model="xgInfo.courseName" show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="副标题:">
						<el-input placeholder="50字" maxlength="50" size="mini" style="width: 400px"
							v-model="xgInfo.courseSubTitle" show-word-limit></el-input>
					</el-form-item>

					<el-form-item label="课件封面:" prop="themePic">
						<el-button @click="chooseRadio(1)" type="primary" size="mini" style="margin-bottom: 10px;">
							图片库上传
						</el-button>
						<el-upload :class="{ hide: true }" :action="uploadUrl" list-type="picture-card" :limit="1"
							:on-success="getPictrueURL" accept=".jpg,.png" :file-list="xgInfo.themePic"
							:on-preview="handlePictureCardPreview" :on-remove="handleRemove"
							:before-upload="beforeUpload">
							<i class="el-icon-plus" />
						</el-upload>
						<el-dialog :visible.sync="dialogDisplay" size="tiny" @close="imagePrevClosed" append-to-body>
							<el-image width="100%" :src="dialogImageUrl"></el-image>
						</el-dialog>
						<span>最多上传1张,建议比例16:9</span>
					</el-form-item>
					<el-form-item label="付费类型:" prop="free" @change="xzLx()">
						<el-radio-group v-model="xgInfo.free">
							<el-radio :label="1">付费</el-radio>
							<el-radio :label="0">免费</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="付费群体:">
						<el-checkbox-group v-model="xgInfo.payGroup">
							<el-checkbox v-for="item in levelList" :key="item.levelCode" :label="item.levelCode">
								{{ item.levelName }}
							</el-checkbox>
							<!-- <el-checkbox label="70">潜在</el-checkbox> -->
							<!-- <el-checkbox :label="70">新客</el-checkbox>
							<el-checkbox :label="60">粉丝</el-checkbox>
							<el-checkbox :label="50">vip</el-checkbox>
							<el-checkbox :label="45">svip</el-checkbox>
							<el-checkbox :label="40">vp</el-checkbox>
							<el-checkbox :label="30">vk</el-checkbox>
							<el-checkbox :label="20">2s</el-checkbox>
							<el-checkbox :label="10">4s</el-checkbox> -->
						</el-checkbox-group>
						<div style="color: #cca771">提示：未选择的则默认免费使用！</div>
					</el-form-item>
					<el-form-item label="课件价格:" prop="coursePrice" v-if="xgInfo.free == 1">
						<el-input size="mini" style="width: 100px" type="number" min="0" v-model="xgInfo.coursePrice">
						</el-input>元
					</el-form-item>
				</div>
				<el-form-item label="课件介绍:" prop="courseIntroduce" v-if="!isShow" label-width="100px">
					<wangeditor v-model="xgInfo.courseIntroduce" style="width: 900px;margin-right: 800px;" />
				</el-form-item>
				<el-form-item label-width="500px">
					<el-button @click="centerDialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="queren()">确 定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<!-- 章节弹框 -->
		<el-dialog :title="title" :visible.sync="centerDialogVisible2" width="30%" center @change="gb()">
			<el-form ref="info2" :model="info2" label-width="90px" label-position="right">
				<el-form-item label="章节:" prop="chapterNo" :rules="[{
					required: true, trigger: 'blur', message: '请输入章节'
				}]">
					<el-input-number v-model="info2.chapterNo" :min="1">
					</el-input-number>
				</el-form-item>
				<el-form-item label="标题:" prop="chapterName" :rules="[{
					required: true, trigger: 'blur', message: '请输入标题'
				}]">
					<el-input v-model="info2.chapterName" maxlength="50" show-word-limit></el-input>
				</el-form-item>
				<el-form-item>
					<el-button @click="centerDialogVisible2 = false">取消</el-button>
					<el-button type="primary" @click="queren2()">确认</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog :title="title" :visible.sync="centerDialogVisible3" width="40%" center @change="gb()">
			<div v-if="geshi == '1'">
				<video width="700px" height="300px" :src="xinXi" controls id="player">
				</video>
			</div>
			<div v-if="geshi == '2'" style="margin: 0 auto;width: 300px;">
				<audio autoplay controls loop="loop" preload="auto" :src="xinXi">
				</audio>
			</div>
			<div v-if="geshi == '3'">
				<wangeditor v-model="xinXi" :disabled="true" />
			</div>
		</el-dialog>
		<el-drawer title="图片选择" :visible.sync="drawer2" direction="rtl" size="40%">
			<SelectPicture :imgNum="1" @imgList='getImg' />
		</el-drawer>
	</el-row>
</template>

<script>
	import wangeditor from "../../../components/wangEditor/wangEditor.vue";
	import httpClient from '../../../util/request.js';
	import SelectPicture from '../../../components/SelectPicture/index.vue'
	export default {
		components: {
			wangeditor,
			SelectPicture
		},
		data() {
			return {
				drawer2: false,
				radioValue: '0',
				uploadUrl: httpClient.imgUrl,
				geshi: "",
				xinXi: "",
				levelList: [],
				// 获取的全部数据
				data: [],
				// 头部展示的数据
				info: {
					status: "",
					courseName: "",
					themePic: "", //图片
					directionName: "", //方向名
					courseCategoryName: [], //类别名
					courseSubTitle: "", //副标题
					created: "", //创建时间
					free: "", //付费类型id
					coursePrice: "", //价格
					lookNum: "", //浏览数
					num: "", //课的节数
					praiseNum: "", //点赞数
					shareNum: "", // * 分享数
					buyNum: "", // * 购买数
					playNum: "", // * 播放量
				},
				info2: {
					chapterNo: "",
					chapterName: "",
					chapterId: "",
				},
				centerDialogVisible: false, //弹出框状态
				centerDialogVisible2: false, //弹出框状态
				centerDialogVisible3: false,
				hideUpload: false, //隐藏上床组件
				dialogDisplay: false, //预览状态
				dialogImageUrl: "", //预览照片
				options: [], //方向数据
				options2: [], //类别数据
				cateListProps: {
					value: "dicId", //匹配响应数据中的id
					label: "dicDesc", //匹配响应数据中的name
					children: "sonDicList", //匹配响应数据中的children
				},
				title: "",
				//修改需要的数据
				xgInfo: {
					courseId: "", //id
					direction: "", //方向
					category: [], //类别
					courseName: "", //标题
					courseSubTitle: "", //副标题
					coursePrice: "", //10000
					themePic: [], //课程主图更新
					free: "", //免费
					courseIntroduce: "", //课程介绍
					status: "", //状态
					payGroup: [],
				},
				//修改的规则
				xgInfoRules: {
					direction: [{
						required: true,
						trigger: "blur",
						message: "请选择方向",
					}, ],
					category: [{
						required: true,
						trigger: "blur",
						message: "请选择分类",
					}, ],
					courseName: [{
						required: true,
						trigger: "blur",
						message: "请输入标题",
					}, ],
					themePic: [{
						required: true,
						trigger: "blur",
						message: "请上传课件封面",
					}, ],
					free: [{
						required: true,
						trigger: "blur",
						message: "请选择付费类型",
					}, ],
					coursePrice: [{
						required: true,
						trigger: "blur",
						message: "请输入课件价格",
						pattern: /^(?!(0[0-9]{0,}$))[0-9]{1,}[.]{0,}[0-9]{0,}$/,
					}, ],
					courseIntroduce: [{
						required: true,
						trigger: "blur",
						message: "请输入课程介绍",
					}, ],
				},
				isShow: true,
				tableData: [],
			};
		},
		methods: {
			chooseRadio() {
				this.drawer2 = true
			},
			getImg(e) {
				console.log(e)
				this.xgInfo.themePic = [];
				[e].forEach(item => {
					this.xgInfo.themePic.push({
						url: item
					})
				})
				this.drawer2 = false
			},
			formatSeconds(value) {
				var theTime = parseInt(value); // 秒
				var middle = 0; // 分
				var hour = 0; // 小时
				if (theTime > 60) {
					middle = parseInt(theTime / 60);
					theTime = parseInt(theTime % 60);
					if (middle > 60) {
						hour = parseInt(middle / 60);
						middle = parseInt(middle % 60);
					}
				}
				var result = "" + parseInt(theTime);
				if (middle > 0) {
					result = "" + parseInt(middle) + ":" + result;
				}
				if (hour > 0) {
					result = "" + parseInt(hour) + ":" + result;
				}
				return result
			},
			gb() {
				this.getInfo();
			},
			getLevel() {
				this.$http.get(`/api/user/userLevel/getLevelDrop`, {}).then((res) => {
					this.levelList = res.data.data
				})
			},
			xzLx() {
				if (this.xgInfo.free == 0) {
					this.xgInfo.coursePrice == "";
				}
			},
			//修改信息
			xiugai() {
				this.centerDialogVisible = true;
				this.isShow = true;
				this.title = "修改信息";
				this.xgInfo.courseId = this.data.courseId;
				this.xgInfo.direction = this.data.direction;
				this.xgInfo.category = this.data.category;
				this.xgInfo.courseName = this.data.courseName;
				this.xgInfo.courseSubTitle = this.data.courseSubTitle;
				this.xgInfo.free = this.data.free;
				this.xgInfo.themePic = [];
				this.xgInfo.themePic.push({
					url: this.data.themePic,
				});
				if (this.xgInfo.themePic[0].url) {
					this.hideUpload = true;
				}
				this.xgInfo.free = this.data.free;
				this.xgInfo.coursePrice = this.data.coursePrice;
				let arr = [];
				if (this.data.payGroup) {
					this.data.payGroup.split(",").forEach((i) => {
						arr.push(i - 0);
					});
					this.xgInfo.payGroup = arr;
				}
			},
			//修改课程介绍
			xiugai2() {
				this.centerDialogVisible = true;
				this.isShow = false;
				this.title = "修改课程介绍";
				this.xgInfo.courseIntroduce = this.data.courseIntroduce;
			},
			//上下架
			sxjia() {
				console.log(this.data.status);
				if (this.data.status == 0) {
					this.xgInfo.status = 1;
				} else if (this.data.status == 1) {
					this.xgInfo.status = 0;
				}
				this.$confirm("此操作将改变上下架状态, 是否继续?", "上下架提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(() => {
						this.$http
							.post(`/api/course/clrCourse/updateCourse`, {
								courseId: this.data.courseId, //id
								status: this.xgInfo.status,
							})
							.then((res) => {
								console.log(res.data);
								if (res.data.status == 0) {
									this.$message.success(res.data.data);
									this.centerDialogVisible = false;
									this.getInfo();
								} else {
									this.$message.error(res.data.msg);
								}
							});
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "已取消",
						});
					});
			},
			//确认
			queren() {
				this.$refs.xgInfo.validate((valid) => {
					if (valid) {
						//修改信息
						if (this.title == "修改信息") {
							let category = "";
							let payGroup = "";
							if (this.xgInfo.payGroup.length > 0) {
								payGroup = this.xgInfo.payGroup.join(",");
							}
							if (this.xgInfo.category.length > 0) {
								category = this.xgInfo.category[1];
							} else {
								category = this.xgInfo.category;
							}
							if (this.xgInfo.free == 0) {
								this.xgInfo.coursePrice = 0
							}
							console.log(this.xgInfo.coursePrice);
							this.$http
								.post(`/api/course/clrCourse/updateCourse`, {
									courseId: this.xgInfo.courseId, //id
									direction: this.xgInfo.direction, //方向
									category: category, //类别
									courseName: this.xgInfo.courseName, //标题
									courseSubTitle: this.xgInfo.courseSubTitle, //副标题
									coursePrice: this.xgInfo.coursePrice, //10000
									themePic: this.xgInfo.themePic[0].url, //课程主图更新
									free: this.xgInfo.free, //免费
									payGroup: payGroup,
								})
								.then((res) => {
									console.log(res.data);
									if (res.data.status == 0) {
										this.$message.success(res.data.data);
										this.centerDialogVisible = false;
										this.getInfo();
									} else {
										this.$message.error(res.data.msg);
									}
								});
						} else if (this.title == "修改课程介绍") {
							this.$http
								.post(`/api/course/clrCourse/updateCourse`, {
									courseId: this.data.courseId, //id
									courseIntroduce: this.xgInfo.courseIntroduce,
								})
								.then((res) => {
									console.log(res.data);
									if (res.data.status == 0) {
										this.$message.success(res.data.data);
										this.centerDialogVisible = false;
										this.getInfo();
									} else {
										this.$message.error(res.data.msg);
									}
								});
						}
					}
				});
			},
			queren2() {
				this.$refs.info2.validate((valid) => {
					if (valid) {
						//修改信息
						if (this.title == "新增章节") {
							this.$http
								.post(`/api/course/clrCourse/addChapter`, {
									chapterNo: this.info2.chapterNo, //章节编号
									chapterName: this.info2.chapterName, //章节名称
									courseId: this.data.courseId, //所属课件ID
								})
								.then((res) => {
									console.log(res.data.status, res.data.msg);
									if (res.data.status == 0) {
										this.$message.success("添加成功");
										this.centerDialogVisible2 = false;
										this.getInfo();
									} else {
										this.$message.error(res.data.msg);
									}
								});
						} else if (this.title == "编辑章节") {
							this.$http
								.post(`/api/course/clrCourse/updateChapter`, {
									chapterNo: this.info2.chapterNo, //章节编号
									chapterName: this.info2.chapterName, //章节名称
									courseId: this.data.courseId, //所属课件ID
									chapterId: this.info2.chapterId,
								})
								.then((res) => {
									console.log(res.data.status);
									if (res.data.status == 0) {
										this.$message.success(res.data.data);
										this.centerDialogVisible2 = false;
										this.getInfo();
									} else {
										this.$message.error(res.data.msg);
									}
								});
						}
					}
				});
			},
			//添加章节
			addZangJie(row) {
				console.log(row);
				this.centerDialogVisible2 = true;
				this.title = "新增章节";
				this.info2.chapterName = "";
			},
			//修改章节
			xgZangJie(row) {
				console.log(row);
				this.centerDialogVisible2 = true;
				this.title = "编辑章节";
				this.info2.chapterNo = row.chapterNo;
				this.info2.chapterName = row.chapterName;
				this.info2.chapterId = row.chapterId;
			},
			//修改状态
			handleStatusChange(row) {
				console.log(row.free);
				if (row.free == 1) {
					this.$http
						.post(`/api/course/clrCourse/updateLesson`, {
							lessonId: row.lessonId,
							chapterId: row.chapterId,
							courseId: row.courseId,
							free: 1,
						})
						.then((res) => {
							if (res.data.status == 0) {
								this.getInfo();
							}
						});
				}
				if (row.free == 0) {
					this.$http
						.post(`/api/course/clrCourse/updateLesson`, {
							lessonId: row.lessonId,
							chapterId: row.chapterId,
							courseId: row.courseId,
							free: 0,
						})
						.then((res) => {
							if (res.data.status == 0) {
								this.getInfo();
							}
						});
				}
			},
			//删除章节
			del(row) {
				console.log(row);
				this.$confirm("此操作将永久删除该章节, 是否继续?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(() => {
						this.$http
							.post(`/api/course/clrCourse/deleteChapter`, {
								courseId: row.courseId,
								chapterId: row.chapterId,
							})
							.then((res) => {
								if (res.data.status == 0) {
									this.$message({
										type: "success",
										message: res.data.data,
									});
									this.getInfo();
								}
							});
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "已取消删除",
						});
					});
			},
			//删除课时
			delLesson(row) {
				console.log(row);
				this.$confirm("此操作将永久删除该课时, 是否继续?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(() => {
						this.$http
							.post(`/api/course/clrCourse/deleteLesson`, {
								courseId: row.courseId,
								lessonId: row.lessonId,
							})
							.then((res) => {
								if (res.data.status == 0) {
									this.$message({
										type: "success",
										message: res.data.data,
									});
									this.getInfo();
								}
							});
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "已取消删除",
						});
					});
			},
			//添加课程
			addKeCheng(row) {
				console.log(row);
				this.$router.push({
					path: "./addKeCheng",
					query: {
						cz: 1,
						chapterId: row.chapterId, //所属章节ID
						courseId: this.data.courseId, //所属课件ID
					},
				});
			},
			//编辑课程
			bj(row) {
				console.log(row);
				this.$router.push({
					path: "./addKeCheng",
					query: {
						cz: 2,
						lessonId: row.lessonId,
						chapterId: row.chapterId,
						courseId: row.courseId,
						fileType: row.fileType,
						free: row.free,
						lessonInfo: row.lessonInfo,
						lessonName: row.lessonName,
						status: row.status,
						testType: row.testType,
					},
				});
			},
			//图片上传之前
			beforeUpload(file) {
				// console.log(file);
				// const isSize = new Promise((resolve, reject) => {
				// 	const width = 16;
				// 	const height = 9;
				// 	const _URL = window.URL || window.webkitURL;
				// 	const img = new Image();
				// 	img.onload = () => {
				// 		//按照一定比例 本例子为4:3
				// 		const valid = img.width / img.height == width / height
				// 		// // 限制必须为竖屏图片(宽必须小于高)
				// 		valid ? resolve() : reject();
				// 	};
				// 	img.src = _URL.createObjectURL(file);
				// }).then(
				// 	() => {
				// 		return file;
				// 	},
				// 	() => {
				// 		this.$message.error('上传图标尺寸限制为16*9比例');
				// 		return Promise.reject();
				// 	},
				// );
				// return isSize
			},
			//上传成功
			getPictrueURL(response, file, fileList) {
				this.xgInfo.themePic.push({
					url: response.data,
				});
				this.hideUpload = fileList.length >= 1;
			},
			// 款式主图预览
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogDisplay = true;
			},
			// 款式主图上传框删除一个图片
			handleRemove(file, fileList) {
				this.xgInfo.themePic = [];
				this.hideUpload = false;
			},
			// 款式主图预览dialog关闭时的回调
			imagePrevClosed() {
				this.dialogImageUrl = "";
			},
			see(item) {
				console.log(item);
				this.centerDialogVisible3 = true;
				this.geshi = item.fileType;
				this.xinXi = item.lessonInfo;
				this.title = item.lessonName;
			},
			getInfo() {
				this.$http
					.post(
						`/api/course/clrCourse/selectCourseById?courseId=${this.$route.query.id}`, {}
					)
					.then((res) => {
						if (res.data.data) {
							this.data = res.data.data;
							this.info.courseName = this.data.courseName;
							this.info.status = this.data.status;
							if (this.data.themePic) {
								this.info.themePic = this.data.themePic;
							}
							this.info.directionName = this.data.directionName;
							this.info.courseSubTitle = this.data.courseSubTitle;
							this.info.created = this.data.created;
							this.info.free = this.data.free;
							this.info.num = this.data.num;
							this.info.coursePrice = this.data.coursePrice;
							this.info.lookNum = this.data.lookNum; //浏览数
							this.info.praiseNum = this.data.praiseNum; //点赞数
							this.info.shareNum = this.data.shareNum; // * 分享数
							this.info.buyNum = this.data.buyNum; // * 购买数
							this.info.playNum = this.data.playNum; // * 播放量
							this.info.courseCategoryName =
								this.data.courseCategoryName.split("---");
							this.tableData = res.data.data.clrChapterDOList;
							this.tableData.forEach((i) => {
								i.clrLessonDOList.forEach((item) => {
									console.log(item.length);
									let time = item.length;
									item.length = this.formatSeconds(item.length)
									let h = Math.floor(time / 3600);
									let m = Math.floor(time / 60);
									let s = Math.floor(time % 60);
									if (h < 10) {
										h = "0" + h;
									}
									if (m < 10) {
										m = "0" + m;
									}
									if (s < 10) {
										s = "0" + s;
									}
									item.length = h + ":" + m + ":" + s;
								});
							});
						}
					});
			},
			//方向
			getInfo2() {
				this.$http
					.get(
						`/api/setting/paiBoCategory/PaiBoCategoryDropDown?dicModular=405`, {}
					)
					.then((res) => {
						// console.log(res.data.data, "方向");
						if (res.data.data.length > 0) {
							res.data.data.forEach((i) => {
								this.options.push({
									label: i.dicDesc,
									value: i.dicId,
								});
							});
						}
					});
			},
			//类别
			getInfo3() {
				this.$http
					.get(
						`/api/setting/paiBoCategory/PaiBoCategoryDropDown?dicModular=82`, {}
					)
					.then((res) => {
						// console.log(res.data.data, "类别");
						if (res.data.data.length > 0) {
							res.data.data.forEach((i) => {
								if (i.sonDicList == null) {
									i.sonDicList = []
								}
							});
							this.options2 = res.data.data;
						}
					});
			},
		},
		created() {
			this.getInfo();
			this.getInfo2();
			this.getInfo3();
			this.getLevel()
			console.log(parseFloat('21: 11'));
		},
	};
</script>

<style scoped>
	/* ::v-deep .el-switch__core {
		width: 50px;
		height: 24px;
		border-radius: 100px;
		border: none;
		background-color: #0000FF;
	}

	::v-deep .el-switch__core::after {
		width: 20px;
		height: 20px;
		top: 2px;
	}

	::v-deep .el-switch.is-checked .el-switch__core::after {
		margin-left: -21px;
	}

	::v-deep .el-switch__label--right {
		position: absolute;
		z-index: 1;
		right: 6px;
		margin-left: 0px;
		color: rgba(255, 255, 255, 0.9019607843137255);
	}

	::v-deep .el-switch__label--right span {
		font-size: 12px;
	}

	
	::v-deep .el-switch__label.is-active {
		display: none;
	}

	
	::v-deep .el-switch__label--left {
		position: absolute;
		z-index: 1;
		left: 5px;
		margin-right: 0px;
		color: rgba(255, 255, 255, 0.9019607843137255);

	}

	::v-deep .el-switch__label--left span {
		font-size: 12px;
	}
 */
	/deep/.hide .el-upload--picture-card {
		display: none;
	}
</style>